function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMilitaryAndWar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.226,2.015C13.226,1.059 13.995,0.29 14.951,0.29L23.001,0.29C23.957,0.29 24.726,1.059 24.726,2.015C24.726,2.971 23.957,3.74 23.001,3.74L21.851,3.74L29.326,14.09L37.692,14.09C38.245,14.09 38.792,14.191 39.309,14.385L46.647,17.138C47.294,17.382 47.726,18 47.726,18.69C47.726,19.38 47.294,19.998 46.647,20.243L39.309,22.995C38.792,23.189 38.245,23.29 37.692,23.29L29.326,23.29L21.851,33.64L23.001,33.64C23.957,33.64 24.726,34.409 24.726,35.365C24.726,36.321 23.957,37.09 23.001,37.09L14.951,37.09C13.995,37.09 13.226,36.321 13.226,35.365C13.226,34.409 13.995,33.64 14.951,33.64L15.526,33.64L15.526,23.29L13.226,23.29L9.301,27.214C8.87,27.646 8.288,27.89 7.677,27.89L6.326,27.89C5.053,27.89 4.026,26.862 4.026,25.59L4.026,20.99C2.753,20.99 1.726,19.962 1.726,18.69C1.726,17.418 2.753,16.39 4.026,16.39L4.026,11.79C4.026,10.518 5.053,9.49 6.326,9.49L7.67,9.49C8.281,9.49 8.863,9.734 9.294,10.166L13.226,14.09L15.526,14.09L15.526,3.74L14.951,3.74C13.995,3.74 13.226,2.971 13.226,2.015ZM7.476,17.54C6.843,17.54 6.326,18.058 6.326,18.69C6.326,19.323 6.843,19.84 7.476,19.84L12.076,19.84C12.708,19.84 13.226,19.323 13.226,18.69C13.226,18.058 12.708,17.54 12.076,17.54L7.476,17.54Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMilitaryAndWar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/military-and-war.a267d702c31b41fa9c8f3a9bff877492.svg";